var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-content-start"},[((_vm.dependencia && _vm.$rest.esTipoUsuario(['Super User','Super Usuario de E3' ,'Jefe de Dependencia','Jefe de Sumario','User Tester'],_vm.user))||_vm.$rest.esTipoUsuario(['Oficial Sumariante'],_vm.user))?_c('Bandeja',{attrs:{"user":_vm.user,"dependencia":_vm.dependencia}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }